import { DirectionsCar } from "@mui/icons-material";
import { Box, CircularProgress, Typography } from "@mui/material";

export const Loader = () => (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '60vh',
        gap: 3
      }}
    >
      <Box sx={{ position: 'relative' }}>
        <CircularProgress
          size={60}
          thickness={4}
          sx={{
            color: '#393939ff',
            animationDuration: '1.5s',
          }}
        />
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
          }}
        >
          <DirectionsCar sx={{ fontSize: 24, color: '#393939ff' }} />
        </Box>
      </Box>
      <Typography 
        variant="h6" 
        color="text.secondary"
        sx={{ 
          fontWeight: 500,
          letterSpacing: 0.5
        }}
      >
        Cargando bitácora de vehículos...
      </Typography>
      <Box sx={{ display: 'flex', gap: 1 }}>
        {[0, 1, 2].map((i) => (
          <Box
            key={i}
            sx={{
              width: 8,
              height: 8,
              borderRadius: '50%',
              backgroundColor: '#393939ff',
              animation: 'pulse 1.5s infinite',
              animationDelay: `${i * 0.2}s`,
              '@keyframes pulse': {
                '0%, 80%, 100%': { opacity: 0.3 },
                '40%': { opacity: 1 },
              },
            }}
          />
        ))}
      </Box>
    </Box>
  );